import { withStore, useGetter, useMutation } from 'vuex-but-for-react';

const CounterContainer = () => {
  return (
    <div>
      <Counter1 />
      <Counter2 />
    </div>
  )
}

const CounterRenderer = ({ value, onChange }) => {
  return (
    <button onClick={onChange}>Increment ({value})</button>
  )
}

const Counter1 = () => {
  const value = useGetter('counter1');
  const handleIncrement = useMutation('COUNTER_1_INCREMENT');

  console.log('Counter 1 render: ', value);

  return (
    <CounterRenderer value={value} onChange={handleIncrement} />
  )
}

const Counter2 = () => {
  const value = useGetter('counter2');
  const handleIncrement = useMutation('COUNTER_2_INCREMENT');

  console.log('Counter 2 render: ', value);

  return (
    <CounterRenderer value={value} onChange={handleIncrement} />
  )
}

const store = {
  state: {
    counter1: 1,
    counter2: 2
  },
  mutations: {
    COUNTER_1_INCREMENT(state) {
      state.counter1++
    },
    COUNTER_2_INCREMENT(state) {
      state.counter2++
    }
  },
  getters: {
    counter1(state) {
      return state.counter1
    },
    counter2(state) {
      return state.counter2
    }
  }
}

export default withStore(CounterContainer, store)